import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ redirectPath = '/login' }) => {
  const { isAuthenticated, user, token } = useAuth();

  // Ajouter des logs pour déboguer
  console.log('ProtectedRoute - État d\'authentification:', { 
    isAuthenticated, 
    hasUser: !!user, 
    hasToken: !!token,
    path: window.location.pathname
  });
  
  // Nous n'avons plus besoin de vérifier isLoading car les données sont chargées immédiatement

  // Rediriger vers la page de connexion si l'utilisateur n'est pas authentifié
  if (!isAuthenticated) {
    console.log('Redirection vers', redirectPath, 'car non authentifié');
    return <Navigate to={redirectPath} replace />;
  }

  // Rendre les routes enfants si l'utilisateur est authentifié
  return <Outlet />;
};

export default ProtectedRoute;
